import { render, staticRenderFns } from "./FireCauseLocationHouseQuestion.vue?vue&type=template&id=5d97333a&scoped=true"
import script from "./FireCauseLocationHouseQuestion.vue?vue&type=script&lang=ts"
export * from "./FireCauseLocationHouseQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d97333a",
  null
  
)

export default component.exports